/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { GeocodingResult } from './';
import {
    GeocodingResultFromJSON,
    GeocodingResultFromJSONTyped,
    GeocodingResultToJSON,
} from './';
import type { MaltUserAgent } from './';
import {
    MaltUserAgentFromJSON,
    MaltUserAgentFromJSONTyped,
    MaltUserAgentToJSON,
} from './';

/**
 * 
 * @export
 * @interface Session
 */
export interface Session {
    /**
     * 
     * @type {string}
     * @memberof Session
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Session
     */
    ip?: string;
    /**
     * 
     * @type {Date}
     * @memberof Session
     */
    date?: Date;
    /**
     * 
     * @type {MaltUserAgent}
     * @memberof Session
     */
    fullUserAgent?: MaltUserAgent;
    /**
     * 
     * @type {GeocodingResult}
     * @memberof Session
     */
    localization?: GeocodingResult;
}

/**
 * Check if a given object implements the Session interface.
 */
export function instanceOfSession(value: object): value is Session {
    return true;
}

export function SessionFromJSON(json: any): Session {
    return SessionFromJSONTyped(json, false);
}

export function SessionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Session {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'ip': json['ip'] == null ? undefined : json['ip'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'fullUserAgent': json['fullUserAgent'] == null ? undefined : MaltUserAgentFromJSON(json['fullUserAgent']),
        'localization': json['localization'] == null ? undefined : GeocodingResultFromJSON(json['localization']),
    };
}

export function SessionToJSON(value?: Session | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'ip': value['ip'],
        'date': value['date'] == null ? undefined : ((value['date']).toISOString()),
        'fullUserAgent': MaltUserAgentToJSON(value['fullUserAgent']),
        'localization': GeocodingResultToJSON(value['localization']),
    };
}

